import { sessionStore, stockActions } from '../../services';
import { StockModule } from '../../util';


const containsStock = () =>{
  const siteSettings = sessionStore.get( 'siteSettings' );
  return siteSettings && StockModule.requestStock( siteSettings.stockModule );
}
export const stockDispatcher = dispatch => ({
  getStocks : (products, hasStockFilter) => containsStock() && dispatch( { type: stockActions.LOADING, products, hasStockFilter })
  .then ( () => dispatch( { type: stockActions.RETRIEVE, products, hasStockFilter }))
});